// extracted by mini-css-extract-plugin
export default {"contenedor":"Flechas_contenedor__hldu8","pregunta":"Flechas_pregunta__IEvXR","respuesta":"Flechas_respuesta__y2ilw","flechaDivisora":"Flechas_flechaDivisora__pIYqc"};